module.exports = __webpack_public_path__ + "static/media/madden-selector-color.f80373c7.png";